/* Candela — cross-document view transitions.

   Two jobs:
   1. Drop the render blocker whenever no transition can actually run (reload,
      unsupported browser, reduced motion), plus a timeout so a slow response
      can never hold first paint indefinitely.
   2. Skip an in-flight transition as soon as the user interacts. Cross-document
      transitions block rendering between the outgoing snapshot and the server
      response, so a click in that window is an INP hit. */

(function () {
  var BLOCKER_ID = 'CandelaViewTransitionBlocker';
  var BLOCKER_TIMEOUT = 1800;

  function dropBlocker() {
    var el = document.getElementById(BLOCKER_ID);
    if (el) el.remove();
  }

  var entry = performance.getEntriesByType('navigation')[0];
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (
    !('startViewTransition' in document) ||
    (entry && entry.type === 'reload') ||
    reducedMotion
  ) {
    dropBlocker();
  }

  setTimeout(dropBlocker, BLOCKER_TIMEOUT);

  /* finished fulfils even when the transition is skipped, so it is only useful
     for cleanup here — never as a failure path. */
  function skipOnInteraction(event) {
    var transition = event.viewTransition;
    if (!transition) return;

    function skip() {
      transition.skipTransition();
    }

    document.addEventListener('pointerdown', skip, { once: true });
    document.addEventListener('keydown', skip, { once: true });

    transition.finished.finally(function () {
      document.removeEventListener('pointerdown', skip);
      document.removeEventListener('keydown', skip);
    });
  }

  /* These fire on window, not on navigation. */
  window.addEventListener('pageswap', skipOnInteraction);
  window.addEventListener('pagereveal', skipOnInteraction);

  var EXCLUDED = ['cart', 'account', 'checkouts'];

  /* Strip the locale prefix so /en-gb/cart is excluded just like /cart. */
  function rootRelative(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return path.indexOf(root) === 0 ? '/' + path.slice(root.length) : path;
  }

  window.addEventListener('pageswap', function (event) {
    if (!event.viewTransition) return;

    var activation = event.activation;
    var target = activation && activation.entry;
    if (!target) return;

    var segment = rootRelative(new URL(target.url).pathname).split('/')[1];
    if (EXCLUDED.indexOf(segment) !== -1) event.viewTransition.skipTransition();
  });
})();
